module.exports = __webpack_public_path__ + "static/media/020-iraq.5af2e671.svg";